import { useSyncExternalStore } from 'react';

// The app follows the system light/dark setting.
const media = window.matchMedia('(prefers-color-scheme: dark)');

function apply() {
  document.documentElement.classList.toggle('dark', media.matches);
  document.documentElement.style.colorScheme = media.matches ? 'dark' : 'light';
}
apply();
media.addEventListener('change', apply);

export function useTheme(): 'light' | 'dark' {
  return useSyncExternalStore(
    (cb) => {
      media.addEventListener('change', cb);
      return () => media.removeEventListener('change', cb);
    },
    () => (media.matches ? 'dark' : 'light'),
  );
}
